import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import AppRoutes from './AppRoutes';
import { useMetadataStore } from '@stores/Metadata/Metadata';
import { useUserStore } from '@stores/User/User';
import FeedbackModal from '@components/FeedbackModal';
import {
  resetSessionExpiryNotification,
  setSessionExpiredHandler
} from '@lib/sessionExpiry';

const App = () => {
  const hasCheckedForcedLogout = useRef(false);
  const [sessionExpiredModalOpen, setSessionExpiredModalOpen] = useState(false);

  const {
    fetchTiposImovel,
    fetchCondicoesImovel,
    fetchChaves,
    fetchCodigosImovel,
    fetchCidades,
    fetchCaracteristicas
  } = useMetadataStore();

  const { token, checkShouldLogoutOnBoot } = useUserStore();

  useEffect(() => {
    setSessionExpiredHandler(async () => {
      const { token: activeToken, logOut } = useUserStore.getState();
      if (!activeToken) return;

      await logOut();
      setSessionExpiredModalOpen(true);
    });

    return () => {
      setSessionExpiredHandler(null);
    };
  }, []);

  useEffect(() => {
    if (!token) {
      hasCheckedForcedLogout.current = false;
      return;
    }

    resetSessionExpiryNotification();
  }, [token]);

  useEffect(() => {
    fetchTiposImovel();
    fetchCondicoesImovel();
    fetchChaves();
    fetchCodigosImovel();
    fetchCidades();
    fetchCaracteristicas();
  }, [
    fetchTiposImovel,
    fetchCondicoesImovel,
    fetchChaves,
    fetchCodigosImovel,
    fetchCidades,
    fetchCaracteristicas
  ]);

  useEffect(() => {
    if (!token || hasCheckedForcedLogout.current) return;

    hasCheckedForcedLogout.current = true;

    const run = async () => {
      const shouldLogout = await checkShouldLogoutOnBoot();
      if (shouldLogout) {
        setSessionExpiredModalOpen(true);
      }
    };

    run();
  }, [token, checkShouldLogoutOnBoot]);

  return (
    <HelmetProvider>
      <Router>
        <AppRoutes />
        <FeedbackModal
          open={sessionExpiredModalOpen}
          variant="error"
          title="Sessão expirada"
          message="Sua sessão na área do corretor expirou. Faça login novamente para continuar."
          buttonLabel="Ir para login"
          onClose={() => {
            setSessionExpiredModalOpen(false);
            window.location.assign('/login');
          }}
        />
      </Router>
    </HelmetProvider>
  );
};

export default App;
